import {useHubQuery} from '../../QueryProvider'

export const useFailedOrderRequests = (customerId: string) => {
  return useHubQuery('failedOrderRequests', [customerId], {
    enabled: !!customerId
  })
}
